export class AttachRestoreTemplateRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "templateId",
            "baseName": "templateId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return AttachRestoreTemplateRequest.attributeTypeMap;
    }
    constructor() {
    }
}
